import { DocumentDetail } from '@/services/healthClaim/useRequestDocumentList/types'
import { CancelDocumentRequestModalHook } from './CancelDocumentRequestModal.hook'
import { Button, Content, DocumentItem, DocumentList, DocumentName, StyledModal } from './styles'
import { CancelDocumentRequestModalProps } from './types'

function CancelDocumentRequestModal({
  isModalOpen,
  onClose,
  onConfirm,
  isLoading = false,
  centered = false,
}: CancelDocumentRequestModalProps) {
  const { modalContent, DocumentRequest } = CancelDocumentRequestModalHook()

  const renderDocumentItem = (item: DocumentDetail, index: number) => (
    <DocumentItem key={index}>
      <DocumentName>
        {index + 1}. {item.documentTypeName} {item.requestDetail && `[${item.requestDetail}]`}
      </DocumentName>
    </DocumentItem>
  )

  return (
    <StyledModal
      open={isModalOpen}
      closable={false}
      width={450}
      centered={centered}
      onCancel={onClose}
      title={modalContent.title}
      footer={[
        <Button key="cancel" onClick={onClose} disabled={isLoading}>
          {modalContent.cancelText}
        </Button>,
        <Button
          key="confirm"
          type="primary"
          onClick={() => onConfirm(DocumentRequest.RequestDocumentHistoryId)}
          loading={isLoading}
          disabled={isLoading}
        >
          {modalContent.confirmText}
        </Button>,
      ]}
    >
      <Content>{modalContent.content}</Content>
      {DocumentRequest?.documentDetails?.length && (
        <DocumentList
          dataSource={DocumentRequest.documentDetails}
          renderItem={renderDocumentItem}
          size="small"
        />
      )}
    </StyledModal>
  )
}

export default CancelDocumentRequestModal
